<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <div class="d-flex justify-content-between mb-3">
        <div>
            <label for="information" class="labelInformation">
                {{title}}
            </label>
        </div>
        <div class="col btn-back text-end">
            <a class="btn btn-secondary" [routerLink]="['/home']">Back</a>
        </div>
    </div>



    <div>


        <div class="row mb-3">
            <div class="col">
                <label for="planName">Plan Type Name<span class="required">*</span></label>
                <input type="text" class="form-control input-label" [(ngModel)]="planType.name" />
            </div>
            <div class="col">
                <label for="planName">Frecuency<span class="required">*</span></label>
                <select class="form-select dropdown input-label" [(ngModel)]="planType.frequencyId">
                    <option value="" disabled selected>Select a Frequency</option>
                    <option *ngFor="let frequency of frequencies" [value]="frequency.frequencyId">{{ frequency.frequencyId }}</option>
                </select>
            </div>



        </div>

        <div class="row mb-3">
            <div class="col">
                <label for="planName">Description</label>
                <textarea class="form-control input-label" [(ngModel)]="planType.description"></textarea>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col">
                <label for="planName">Is Pool</label>

                <input type="checkbox" class="checkbox" id="active" name="activePlan" [(ngModel)]="planType.isPool" />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col">
                <button class="btn btn-primary float-end" (click)="savePlanType()" [disabled]="!planType.name || !planType.frequencyId">Save</button>
            </div>
        </div>



    </div>
</div>